export enum SegmentEvents {
  // Auth flow
  SignUpViewed = 'Sign Up Viewed',
  SignUpCompleted = 'Sign Up Completed',
  CreateAccountViewed = 'Create Account Viewed',
  CreateAccountCompleted = 'Create Account Completed',
  SignInViewed = 'Sign In Viewed',
  SignInCompleted = 'Sign In Completed',
  CodeVerificationViewed = 'Code Verification Viewed',
  CodeVerificationCompleted = 'Code Verification Completed',

  AddPetViewed = 'Add Pet Viewed',
  AddPetCompleted = 'Add Pet Completed',
  AddPetPhotoViewed = 'Add Pet Photo Viewed',
  AddPetPhotoCompleted = 'Add Pet Photo Completed',
  AddPetPhotoSkipped = 'Add Pet Photo Skipped',
  PetDetailsViewed = 'Pet Details Viewed',
  PetDetailsCompleted = 'Pet Details Completed',

  ServiceRequirementsViewed = 'Service Requirements Viewed',
  ServiceRequirementsCompleted = 'Service Requirements Completed',

  ServicePreferencesViewed = 'Service Preferences Viewed',
  ServicePreferencesCompleted = 'Service Preferences Completed',

  HomeAccessViewed = 'Home Access Viewed',
  HomeAccessCompleted = 'Home Access Completed',

  CaregiverPreferencesViewed = 'Caregiver Preferences Viewed',
  CaregiverPreferencesCompleted = 'Caregiver Preferences Completed',

  CaregiversRecommendationViewed = 'Caregivers Recommendation Viewed',
  CaregiversRecommendationCompleted = 'Caregivers Recommendation Completed',

  RequestSummaryViewed = 'Request Summary Viewed',
  RequestSummaryCompleted = 'Request Summary Completed',
  RequestSummaryFailed = 'Request Summary Failed',

  AddPaymentCardViewed = 'Add Payment Card Viewed',
  AddPaymentCardCompleted = 'Add Payment Card Completed',
  AddPaymentCardFailed = 'Add Payment Card Failed',

  BookingConfirmationViewed = 'Booking Confirmation Viewed',

  // Walmart Flow Events
  walmartSignUpSignInViewed = 'Walmart Sign Up/Sign In Viewed',
  walmartCreateAccountViewed = 'Walmart Create Account Viewed',
  walmartCreateAccountCompleted = 'Walmart Create Account Completed',
  walmartSignInViewed = 'Walmart Sign In Viewed',
  walmartSignInCompleted = 'Walmart Sign In Completed',
  walmartCodeVerificationViewed = 'Walmart Code Verification Viewed',
  walmartPromoCodeNotAppliedViewed = 'Walmart Promo Code Not Applied Viewed',
  walmartPromoCodeSuccessViewed = 'Walmart Promo Code Success Viewed',
  walmartPromoCodeSuccessCompleted = 'Walmart Promo Code Success Completed',
  walmartBookNowStarted = 'Walmart Book Now Started',
  walmartBookNowCompleted = 'Walmart Book Now Completed',
  walmartBookLaterViewed = 'Walmart Book Later Viewed',

  // Experiment Events
  ExperimentEvaluated = 'Experiment Evaluated',

  // Standard Events
  LandingPageClick = 'Landing Page Click',
}